<template>
  <v-navigation-drawer
    v-if="!rail"
    app
    permanent
    class="bg-[#f8fafc] px-6 shadow-md w-[270px] flex flex-col"
    :rail="rail"
  >
    <div class="flex items-center justify-between w-full py-4 px-2">
      <img src="/assets/aprova.svg" alt="Logo" class="h-12 w-20" />
      <v-icon class="cursor-pointer" @click="rail = true">mdi-chevron-double-left</v-icon>
    </div>
    <v-list class="flex-1">
      <v-list-item
        to="/student/open-exams"
        :active="$route.path === '/student/open-exams'"
        prepend-icon="mdi-clipboard-list-outline"
        class="rounded-lg transition-all font-semibold text-sm hover:bg-[#a8cee6] hover:text-[#2182BF] px-4 py-3"
      >
        Avaliações em aberto
      </v-list-item>
      <v-list-item
        to="/student/completed-exams"
        :active="$route.path === '/student/completed-exams'"
        prepend-icon="mdi-check-circle-outline"
        class="rounded-lg transition-all font-semibold text-sm hover:bg-[#a8cee6] hover:text-[#2182BF] px-4 py-3"
      >
        Avaliações concluídas
      </v-list-item>
    </v-list>

    <div class="border-t border-[#e6e6e6] pt-6 pb-4 mt-10">
      <UsercardAvatarComponent :showEditProfile="false" />
    </div>
  </v-navigation-drawer>
  <v-navigation-drawer v-else app permanent class="bg-[#f8fafc]" :rail="rail">
    <div class="flex justify-center pt-5">
      <v-icon class="cursor-pointer" @click="rail = false">mdi-chevron-double-right</v-icon>
    </div>
    <div class="flex-1 flex flex-col justify-center pt-4">
      <v-list nav class="space-y-2">
        <v-tooltip text="Avaliações que ainda não foram realizadas" location="right">
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              to="/student/open-exams"
              :active="$route.path === '/student/open-exams'"
              prepend-icon="mdi-clipboard-list-outline"
              class="rounded-lg transition-all font-semibold text-sm hover:bg-[#B8C8EE] hover:text-[#336AE9]"
            >
            </v-list-item>
          </template>
        </v-tooltip>
        <v-tooltip text="Avaliações já finalizadas" location="right">
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              to="/student/completed-exams"
              :active="$route.path === '/student/completed-exams'"
              prepend-icon="mdi-check-circle-outline"
              class="rounded-lg transition-all font-semibold text-sm hover:bg-[#B8C8EE] hover:text-[#336AE9]"
            >
            </v-list-item>
          </template>
        </v-tooltip>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UsercardAvatarComponent from '../user/UsercardAvatarComponent.vue'

const rail = ref(false)
</script>
